/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatrixCarePatient } from './MatrixCarePatient';
import {
    MatrixCarePatientFromJSON,
    MatrixCarePatientFromJSONTyped,
    MatrixCarePatientToJSON,
    MatrixCarePatientToJSONTyped,
} from './MatrixCarePatient';

/**
 * 
 * @export
 * @interface CreateMatrixCarePatientRequest
 */
export interface CreateMatrixCarePatientRequest {
    /**
     * 
     */
    upload: boolean;
    /**
     * 
     */
    patient: MatrixCarePatient;
}

/**
 * Check if a given object implements the CreateMatrixCarePatientRequest interface.
 */
export function instanceOfCreateMatrixCarePatientRequest(value: object): value is CreateMatrixCarePatientRequest {
    if (!('upload' in value) || value['upload'] === undefined) return false;
    if (!('patient' in value) || value['patient'] === undefined) return false;
    return true;
}

export function CreateMatrixCarePatientRequestFromJSON(json: any): CreateMatrixCarePatientRequest {
    return CreateMatrixCarePatientRequestFromJSONTyped(json, false);
}

export function CreateMatrixCarePatientRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMatrixCarePatientRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'upload': json['upload'],
        'patient': MatrixCarePatientFromJSON(json['patient']),
    };
}

export function CreateMatrixCarePatientRequestToJSON(json: any): CreateMatrixCarePatientRequest {
    return CreateMatrixCarePatientRequestToJSONTyped(json, false);
}

export function CreateMatrixCarePatientRequestToJSONTyped(value?: CreateMatrixCarePatientRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'upload': value['upload'],
        'patient': MatrixCarePatientToJSON(value['patient']),
    };
}

